import { Helmet } from 'react-helmet-async';
import { Routes, Route } from 'react-router-dom';
import TeamChatLayout from '@/components/inbox/components/team-chat/TeamChatLayout';

const InboxNotFound = () => (
  <div className="flex min-h-screen items-center justify-center bg-muted">
    <div className="text-center">
      <h1 className="mb-4 text-4xl font-bold">404</h1>
      <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
      <a href="/inbox" className="text-primary underline hover:text-primary/90">
        Return to Inbox
      </a>
    </div>
  </div>
);

export default function Inbox({ isGlobalDarkMode = false }: { isGlobalDarkMode?: boolean }) {
  return (
    <>
      <Helmet>
        <title>Inbox | Messages</title>
        <link rel="canonical" href="/inbox" />
      </Helmet>

      <div className="w-full h-full">
        <Routes>
          <Route path="/" element={<TeamChatLayout isGlobalDarkMode={isGlobalDarkMode} />} />
          <Route path=":chatId" element={<TeamChatLayout isGlobalDarkMode={isGlobalDarkMode} />} />
          <Route path="*" element={<InboxNotFound />} />
        </Routes>
      </div>
    </>
  );
}
